import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CommanSubscribeService } from '../core/services/comman-subscribe.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-svg',
  templateUrl: './svg.component.html',
  styleUrls: ['./svg.component.scss'],
})
export class SvgComponent  {
  
  @Input() icon;
  @Input() color: string;
  @Input() hoverColor: string;
  @Input() backgroundColor:string;

  constructor() { }

}
